import { useScreenSize } from '@repo/utils';

import { tw } from '../../utils';
import Icon from '../Icon';
import { Loader } from '../Loader';

export interface IconButtonProps {
  icon: string;
  label: string;
  theme?: 'primary' | 'secondary';
  fontSize?: 'default' | 'small' | 'text-sm' | 'text-xs';
  folder?: string;
  isLoading?: boolean;
}

export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  label,
  theme = 'primary',
  fontSize = 'text-sm',
  folder = 'core',
  isLoading = false,
}: IconButtonProps) => {
  const { isMobile } = useScreenSize();

  return (
    <div
      className={tw(
        'aspect-square h-[60px] max-h-[60px] max-w-[60px] md:h-[80px] md:max-h-[80px] md:max-w-[80px]',
        'flex flex-col items-center justify-center gap-0.5',
        'rounded-xl px-1.5 backdrop-blur-[9px] md:rounded-2xl md:px-3',
        theme === 'primary' && 'bg-white/70 text-[#181818]',
        theme === 'secondary' && 'bg-[#181818]/70 text-white',
        fontSize === 'small' ? 'text-[11px] md:text-xs' : 'text-xs md:text-sm',
      )}
      style={{
        boxShadow:
          '4px 4px 26px 0px rgba(255, 255, 255, 0.05) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset, 0px 5.716px 5.716px 0px rgba(0, 0, 0, 0.25)',
      }}
    >
      {isLoading ? (
        <Loader
          theme={theme}
          size='large'
        />
      ) : (
        <>
          <Icon
            folder={folder}
            name={icon}
            height={isMobile ? 25 : 30}
            width={isMobile ? 25 : 30}
          />
          <span className={tw(fontSize, fontSize === 'text-xs' && 'mt-1')}>
            {label}
          </span>
        </>
      )}
    </div>
  );
};
